import type { FontSchemaType } from "../../font";
import type { Distribution } from "../../types";
import { useDevice } from "../../useDevice";
import Box from "../Box";
import type { Stat } from "../RowStats";
import ScrollContainer from "../ScrollContainer";
import type { FreeContentBannerProps } from "./FreeContentBanner";
import StudyPackView from "./StudyPackView";
import type { SectionTag } from "./TagsSectionList";

const StudyPackApplet = ({
	renderNestedExamChips,
	distribution,
	donutProgressData,
	donutProgressColorScale,
	productTitle,
	productImage,
	sectionTags,
	stats,
	handleClickListItem,
	appFont,
	freeContentBanner,
}: {
	renderNestedExamChips?: () => React.ReactNode;
	stats?: Stat[];
	distribution: Distribution;
	donutProgressData?: { x: string; y: number }[];
	donutProgressColorScale?: string[];
	productTitle: string;
	productImage: string;
	sectionTags: SectionTag[];
	handleClickListItem: (selectedTagId: number, locked?: boolean) => void;
	appFont?: FontSchemaType;
	handleFeedbackNavigation: (toggleShowFeedbackDialog: () => void) => void;
	freeContentBanner?: FreeContentBannerProps;
}) => {
	const { isMobile } = useDevice();
	return (
		<Box position="relative" flexGrow={1} height="100%">
			<ScrollContainer
				maxWidth="sm"
				contentContainerStyle={{
					paddingHorizontal: isMobile ? 0 : 16,
					paddingBottom: 96,
				}}
				// biome-ignore lint/a11y/useSemanticElements: <explanation>
				role="main"
			>
				{renderNestedExamChips?.()}
				<StudyPackView
					distribution={distribution}
					donutProgressData={donutProgressData}
					donutProgressColorScale={donutProgressColorScale}
					productTitle={productTitle}
					productImage={productImage}
					stats={stats}
					sectionTags={sectionTags}
					handleClickListItem={handleClickListItem}
					appFont={appFont}
					freeContentBanner={freeContentBanner}
				/>
			</ScrollContainer>
		</Box>
	);
};

export default StudyPackApplet;
